export default "__VITE_ASSET__72ffd276__"